export default __webpack_public_path__ + "static/Digital_Spec_275x550_Artvizit.co-d5de2d730340ca045a52d97de8137e45.jpg";